import * as SlickSlider from './components/SlickSlider.css';

export default {
	SlickSlider
};
